<template>
  <div class="pb-1">
    <img :src="visionboardPreview.src" class="visionboard-preview" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    // visionboardPreview: {}
  },
  computed: {
    ...mapGetters("app", [
      'sidebar',
      'visionboardPreview',
    ]),
  },
};
</script>

<style>
.visionboard-preview {
  border: 1px solid #a29b9b;
  width: 185px;
  height: 100px;
  background-color: black;
  margin: 5px 0;
  clear: both;
}
</style>
